var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('results',{attrs:{"collapsed":_vm.leftSidebarCollapsed}}),_c('v-map'),_c('filters',{attrs:{"collapsed":_vm.rightSidebarCollapsed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }